var _classCallCheck = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/aaronlynanderson/Documents/wyohackathon/wyohackathon/app/node_modules/@babel/runtime/helpers/createClass");

var EventEmitter = require('../lib/EventEmitter');

var Signer =
/*#__PURE__*/
function () {
  "use strict";

  function Signer() {
    _classCallCheck(this, Signer);

    this.events = new EventEmitter();
    this.accounts = [];
  }

  _createClass(Signer, [{
    key: "isAvailable",
    value: function isAvailable() {
      return true;
    }
  }, {
    key: "getAccounts",
    value: function getAccounts() {
      return this.accounts;
    }
  }, {
    key: "hasAccount",
    value: function hasAccount(account) {
      return this.getAccounts().map(function (address) {
        return address.toLowerCase();
      }).indexOf(account.toLowerCase()) !== -1;
    }
  }, {
    key: "signTx",
    value: function signTx() {
      throw new Error('signTx() not implemented');
    }
  }, {
    key: "signMsg",
    value: function signMsg() {
      throw new Error('singMsg() not implemented');
    }
  }, {
    key: "shouldSkipSigning",
    value: function shouldSkipSigning() {
      return false;
    }
  }, {
    key: "onAccountChange",
    value: function onAccountChange(callback) {
      this.events.on('accountChange', callback);
    }
  }, {
    key: "permissions",
    value: function permissions() {
      return [];
    }
  }, {
    key: "invoke",
    value: function invoke(action, account) {
      throw new Error('invoke not implemented');
    }
  }]);

  return Signer;
}();

module.exports = Signer;